/*
PROV: COHINT001.BF.FCXWX6FA5T
REQ: SYS-ARCH-15
WHY: Frontend application module.
*/

import { createLogger } from "@cohorta/shared/observability/log";

export const logger = createLogger({ service: "admin" });
